<template>
  <div class="title" :class="{ shadow: shadow }">
    <div class="back" v-if="!viewInfo.pageIndex" @click="backFn">
      <i class="el-icon-arrow-left" />
      返回
    </div>
    {{ viewInfo.title }}
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      back: false,
      shadow: true,
    }
  },
  methods: {
    backFn() {
      if(this.$route.query.pathTo == 'businessAcceptable'&& !this.$route.query.code ){
        this.$router.go(-1)
        return
      }
      if (
        this.$route.query.path != '/myBusiness' &&
        this.$route.path == '/businessDetail'
      ) {
        this.$router.push('/businessAll')
      } else if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/vip')
      }
    },
  },
  computed: {
    ...mapState(['viewInfo']),
  },
}
</script>
<style lang="scss" scoped>
.title {
  position: relative;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 600;
  color: var(--color_mainText);
  background-color: #fff;
  z-index: 10;

  .back {
    position: absolute;
    font-size: 12px;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--color_mainText);
    display: flex;
    align-items: center;
    width: max-content;
    i {
      font-size: 18px;
      font-weight: 600;
    }
  }
}
.shadow {
  box-shadow: 0 3px 5px var(--color_shadow);
}
</style>
